const inFlightByChatId = new Map<string, Promise<unknown>>()
const lastLocalSendAtByChatId = new Map<string, number>()

const RECENT_LOCAL_SEND_MS = 2500

export function isChatSendInFlight(chatId: string): boolean {
    return inFlightByChatId.has(chatId)
}

/**
 * Tracks an in-flight send so a ChatView remount (permissions flash, spinner)
 * cannot start a second createMessage for the same chat.
 */
export function trackChatSend<T>(chatId: string, send: Promise<T>): Promise<T> {
    inFlightByChatId.set(chatId, send)
    lastLocalSendAtByChatId.set(chatId, Date.now())
    return send.finally(() => {
        if (inFlightByChatId.get(chatId) === send) {
            inFlightByChatId.delete(chatId)
        }
    })
}

export function wasChatSentFromThisTabRecently(chatId: string): boolean {
    const sentAt = lastLocalSendAtByChatId.get(chatId)
    return sentAt != null && Date.now() - sentAt < RECENT_LOCAL_SEND_MS
}
